<lib-nav-menu [menuItems]="menuItems" [version]="appVersion"></lib-nav-menu>
